import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getListConservation = async () => {
  const response = await axios.get(`${API_BASE_URL}/status`);
  return response;
};
